<ion-list class="lang-list-box">
    <ion-item *ngFor="let item of this.inputs" (click)=clickedLanguage(item.value)  [ngClass]="{'curr': item.checked}">
        <ion-label>{{item.label}}</ion-label>
        <ion-icon *ngIf="item.checked" name="checkmark" slot="end"></ion-icon>
    </ion-item>
</ion-list>
